const TrustSection = () => {
  return (
    <section className="py-16 bg-white border-b border-silver-light/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-graphite mb-4">
            Tu empresa de confianza en <span className="text-primary">Castelldefels</span>
          </h2>
          <p className="text-lg text-gray-medium max-w-3xl mx-auto">
            Ofrecemos <a href="https://vilanova.justclean.es/" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary-dark transition-colors cursor-pointer">servicios integrales de vaciado de pisos</a>, locales y limpieza extrema con la máxima profesionalidad y discreción. Nuestro equipo cuenta con años de experiencia en el sector.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-5xl font-bold text-primary mb-2">+500</div>
            <div className="text-gray-medium font-medium">Servicios realizados</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-primary mb-2">24/7</div>
            <div className="text-gray-medium font-medium">Disponibilidad</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-primary mb-2">100%</div>
            <div className="text-gray-medium font-medium">Satisfacción</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-primary mb-2">+10</div>
            <div className="text-gray-medium font-medium">Años experiencia</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
